import React from 'react';

import {formatDateTime} from 'utils/datetime';

import './styles.css';

const Message = ({name, createdAt, text, showMoreButton, toggleShowMore}) => (
  <div className="Message">
    <div className="nameAndHour">
      <div className="name">{name}</div>
      <div className="hour">{formatDateTime(createdAt)}</div>
    </div>
    <div className="text">
      <span>{text}</span>
      {showMoreButton && (
        <span className="seeMore" onClick={toggleShowMore}>
          {' '}
          see more
        </span>
      )}
    </div>
  </div>
);

export default Message;
